import { createReducer, on } from '@ngrx/store';
import {
  AdminDomain,
  AdminDomainDetail,
  AdminDomainsListMeta,
} from '../models/admin-domain.model';
import * as AdminDomainsActions from './admin-domains.actions';
import { ApiTableFilter } from '../../../shared/models/table-filter.model';

export interface AdminDomainsQueryState {
  search?: string;
  filters?: ApiTableFilter[];
  filterLink?: string;
}

export interface AdminDomainsState {
  domains: AdminDomain[];
  meta: AdminDomainsListMeta | null;
  isLoading: boolean;
  selectedDomain: AdminDomainDetail | null;
  isDetailLoading: boolean;
  isSubmitting: boolean;
  error: string | null;
  lastQuery: AdminDomainsQueryState;
}

export const initialAdminDomainsState: AdminDomainsState = {
  domains: [],
  meta: null,
  isLoading: false,
  selectedDomain: null,
  isDetailLoading: false,
  isSubmitting: false,
  error: null,
  lastQuery: {},
};

export const adminDomainsReducer = createReducer(
  initialAdminDomainsState,

  on(AdminDomainsActions.loadAdminDomains, (state, action) => ({
    ...state,
    isLoading: true,
    error: null,
    lastQuery: {
      search: action.search,
      filters: action.filters,
      filterLink: action.filterLink,
    },
  })),
  on(AdminDomainsActions.loadAdminDomainsSuccess, (state, { domains, meta }) => ({
    ...state,
    domains,
    meta,
    isLoading: false,
  })),
  on(AdminDomainsActions.loadAdminDomainsFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),

  on(AdminDomainsActions.loadAdminDomainDetail, (state) => ({
    ...state,
    isDetailLoading: true,
    selectedDomain: null,
  })),
  on(AdminDomainsActions.loadAdminDomainDetailSuccess, (state, { domain }) => ({
    ...state,
    selectedDomain: domain,
    isDetailLoading: false,
  })),
  on(AdminDomainsActions.loadAdminDomainDetailFailure, (state, { error }) => ({
    ...state,
    isDetailLoading: false,
    error,
  })),

  on(AdminDomainsActions.updateDomainSettings, (state) => ({
    ...state,
    isSubmitting: true,
    error: null,
  })),
  on(AdminDomainsActions.updateDomainSettingsSuccess, (state) => ({
    ...state,
    isSubmitting: false,
  })),
  on(AdminDomainsActions.updateDomainSettingsFailure, (state, { error }) => ({
    ...state,
    isSubmitting: false,
    error,
  })),

  on(AdminDomainsActions.clearSelectedAdminDomain, (state) => ({
    ...state,
    selectedDomain: null,
    isDetailLoading: false,
  })),

  on(AdminDomainsActions.resetAdminDomainsState, () => initialAdminDomainsState),
);
